import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import { ArrowBackIosNewRounded, ArrowForwardIosRounded } from '@mui/icons-material';

import { Button } from '@/mui/components';

import styles from './Arrow.module.scss';

function Arrow({ isNext = false, ...props }) {
  return (
    <Button
      className={classNames(props.className, styles.Button, {
        [styles.Button___prev]: !isNext,
        [styles.Button___next]: isNext,
      })}
      variant="text"
      shape="square"
      color="inherit"
      size="small"
      onClick={props.onClick}
      style={{
        height: props.height,
      }}
    >
      {isNext ? <ArrowForwardIosRounded fontSize="xLarge" /> : <ArrowBackIosNewRounded fontSize="xLarge" />}
    </Button>
  );
}

Arrow.propTypes = {
  className: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  isNext: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default Arrow;
